import {
  InfoCircle,
} from "react-bootstrap-icons";
import React, { useEffect, useState } from "react";
import { MdPower } from "react-icons/md";
import { FaWifi } from "react-icons/fa";
import { IoVideocam } from "react-icons/io5";
import { FaStar } from "react-icons/fa";
import { BsShieldFillCheck } from "react-icons/bs";
import { use } from "react";
import { getAddOnServicesList } from "../../services/Networkcall";
import { errorAlert } from "../common/Alert";
import { Button, Form, Image, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";

const  ExtrasSection = ({ locationDetail, bookingType, selectedAddOns, addOnServicesList, setAddOnServicesList, setConfirm }) => {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [localSelectedAddOns, setLocalSelectedAddOns] = useState([]);

  // =======================================
  // FETCH LOCATION BASED ADDONSERVICE LIST
  // =======================================
  const getAddOnServices = async () => {
    setLoading(true)
    const res = await getAddOnServicesList(locationDetail?._id);
    try {
      if (res.success) {
        const mData = res.data.map((s) => { return { ...s, isSelected: s.isFree ? true : false } })
        setAddOnServicesList(mData);
      } else {
        errorAlert({ message: res.message })
      }
    } catch (err) {
      errorAlert({message: err?.response?.data?.message || err?.message ||  "something went wrong" })
    } finally {
      setLoading(false)
    }
  }



  // =======================================
  // ADDONSERVICE PRICE BASED ON BOOKING TYPE
  // =======================================

  const getServicePriceBasedOnBookingType = ({ service, bookingType }) => {
    let price = null;
    switch (bookingType) {
      case "DAY":
        price = service?.dayPrice?.price;
        break;
      case "WEEKLY":
        price = service?.weeklyPrice?.price;
        break;
      case "MONTHLY":
        price = service?.monthlyPrice?.price;
        break;
      case "MONTHLY_SUBSCRIPTION":
        price = service?.monthlySubscriptionPrice?.price;
        break;
      default:
        console.warn(`Unknown booking type: ${bookingType}`);
    }

    return price;
  };



  // =======================================
  // SELECTED ADDON SERVICE 
  // =======================================

  const handleToggleAddOn = (id) => {
    setAddOnServicesList((prev) =>
      prev.map((addOn) =>
        addOn._id === id
          ? {
            ...addOn,
            isSelected:
              !addOn.isSelected
          }
          : addOn
      )
    );
  };


  // =======================================
  // ADDON SERVICE TOOLTIP DESCRIPTION
  // =======================================
  const renderTooltip = (props, name, description) => (
    <Tooltip id="button-tooltip" {...props} style={{ ...props.style, Width: "350px" }}>
      <div className="text-start">
        <strong>{name}</strong>
        {description && <div className="mt-1">{description}</div>}
      </div>
    </Tooltip>
  );


  // =======================================
  // EFFECTS
  // =======================================

  useEffect(() => { 
    getAddOnServices(); 
  }, [locationDetail, bookingType])


  return (
    <section className="card extras-card mt-3">
      <h4>
        Enhance Your Parking <span>(Optional)</span>
      </h4>

      {loading ? <div className="d-flex py-5 justify-content-center align-items-center py-4">
        <Spinner animation="border" variant="primary" />
      </div> :

        (addOnServicesList.map((service) => (
          <div key={service._id} className="extra-row">

            {/* LEFT */}
            <div className="left">
              <Image src={service?.image || "assets/images/imageplaceholder.png"} width={50} height={50} className="object-fit-fill" />


              <div>
                <div className="extra-row-title">
                  {service.name}
                  {service.serviceType && (
                    <span className="tag ms-2">{service.serviceType}</span>
                  )}
                </div>
                <small>{service.subtitle}</small>
              </div>
            </div>

            {/* RIGHT */}
            <div className="right flex-column align-items-end">
              <div className="price-box">
                <div className="price fw-bold">
                  <span className="text-primary fs-5">{service?.isFree ? "Free" : `$ ${getServicePriceBasedOnBookingType({ service: service, bookingType: bookingType })}`}</span>
                  {!service?.isFree && <span>/ night</span>}
                </div>

              </div>

              <div className="price-box flex-row gap-0">

                <Form.Check
                  type="switch"
                  id={`custom-switch-${service?._id}`}
                  className="fs-3"
                  checked={service?.isFree || service?.isSelected}
                  onChange={() => !service?.isFree && handleToggleAddOn(service?._id)}
                />
                <div >
                  <OverlayTrigger placement="bottom" // Position of the tooltip
                    delay={{ show: 250, hide: 400 }}
                    overlay={(props) => renderTooltip(props, service?.name, service?.description)}
                  >
                    <InfoCircle className="info cursor-pointer" />

                  </OverlayTrigger>
                </div>

              </div>
            </div>

          </div>
        )))
      }



      <div className="extras-total">
        <Button variant='primary' size='sm' onClick={()=>setConfirm(true)}>Confirm</Button> 
      </div>
    </section>
  );
}

export default React.memo(ExtrasSection);
